import SignUpForm from '@/components/forms/sign-up-form';

const SignUpPage = () => {
  return <SignUpForm />;
};

export default SignUpPage;
